import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { Label } from '../ui/label';
import { CheckCircle, XCircle } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const ApproveRejectModal = ({ isOpen, onClose, rental, truck, action, onSuccess, language = 'pt-BR' }) => {
  const [loading, setLoading] = useState(false);
  const [motivo, setMotivo] = useState('');

  const isApprove = action === 'approve';

  const handleSubmit = async () => {
    if (!isApprove && !motivo.trim()) {
      toast.error(language === 'pt-BR' ? 'Digite o motivo da rejeição' : 'Enter rejection reason');
      return;
    }

    setLoading(true);
    try {
      const token = sessionStorage.getItem('access_token');
      const API_URL = process.env.REACT_APP_BACKEND_URL;

      if (isApprove) {
        await axios.put(`${API_URL}/api/rentals/${rental.id}/approve`, {}, {
          headers: { Authorization: `Bearer ${token}` }
        });
        toast.success(language === 'pt-BR' ? '✅ Aluguel aprovado!' : '✅ Rental approved!');
      } else {
        await axios.put(`${API_URL}/api/rentals/${rental.id}/reject`, { motivo }, {
          headers: { Authorization: `Bearer ${token}` }
        });
        toast.success(language === 'pt-BR' ? 'Solicitação rejeitada' : 'Request rejected');
      }

      onSuccess();
      onClose();
      setMotivo('');
    } catch (error) {
      console.error('Erro:', error);
      toast.error(language === 'pt-BR' ? 'Erro ao processar' : 'Processing error');
    } finally {
      setLoading(false);
    }
  };

  if (!rental || !truck) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            {isApprove ? (
              <>
                <CheckCircle className="h-5 w-5 text-green-600" />
                {language === 'pt-BR' ? 'Aprovar Solicitação' : 'Approve Request'}
              </>
            ) : (
              <>
                <XCircle className="h-5 w-5 text-red-600" />
                {language === 'pt-BR' ? 'Rejeitar Solicitação' : 'Reject Request'}
              </>
            )}
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <div className="bg-gray-50 p-3 rounded">
            <p className="font-semibold">{rental.pm_name}</p>
            <p className="text-sm text-gray-600">{truck.modelo} ({truck.placa})</p>
            <p className="text-xs text-gray-500 mt-1">
              {language === 'pt-BR' ? 'Início:' : 'Start:'} {new Date(rental.data_inicio_solicitada).toLocaleDateString('en-US', { timeZone: 'America/New_York', month: '2-digit', day: '2-digit', year: 'numeric' })}
            </p>
          </div>

          {isApprove ? (
            <div className="bg-green-50 p-3 rounded border border-green-200">
              <p className="text-sm text-green-800">
                {language === 'pt-BR' 
                  ? '✅ Ao aprovar, o PM receberá uma notificação e poderá fazer o check-in no dia da retirada.' 
                  : '✅ Upon approval, the PM will receive a notification and can check-in on pickup day.'}
              </p>
            </div>
          ) : (
            <div>
              <Label>{language === 'pt-BR' ? 'Motivo da Rejeição' : 'Rejection Reason'} *</Label>
              <Textarea 
                value={motivo}
                onChange={(e) => setMotivo(e.target.value)}
                placeholder={language === 'pt-BR' ? 'Explique o motivo...' : 'Explain the reason...'}
                rows={4}
              />
            </div>
          )}
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={loading}>
            {language === 'pt-BR' ? 'Cancelar' : 'Cancel'}
          </Button>
          <Button 
            onClick={handleSubmit} 
            disabled={loading}
            className={isApprove ? 'bg-green-600 hover:bg-green-700' : 'bg-red-600 hover:bg-red-700'}
          >
            {loading 
              ? (language === 'pt-BR' ? 'Processando...' : 'Processing...') 
              : (isApprove 
                  ? (language === 'pt-BR' ? '✅ Confirmar Aprovação' : '✅ Confirm Approval')
                  : (language === 'pt-BR' ? '❌ Confirmar Rejeição' : '❌ Confirm Rejection')
                )
            }
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ApproveRejectModal;
